
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/about-us",
      function () {
        return require("private-next-pages/3catinfo/about-us/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/about-us"])
      });
    }
  